import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { VersionHistoryChangesPanelComponent } from '@components/version-history-changes-panel/version-history-changes-panel.component';
import { ChangeStatus, ChangesObject, ChannelOverview } from 'icreate/common/models/versions-history';

@Component({
    selector: 'app-channel-overview-panel',
    templateUrl: './channel-overview-panel.component.html',
    styleUrls: [
        './channel-overview-panel.component.css',
        '../version-history-changes-panel/version-history-changes-panel.component.css',
    ],
    standalone: false,
})
export class ChannelOverviewPanelComponent extends VersionHistoryChangesPanelComponent {
    @Input() changes: ChannelOverview[];

    isAddedElement = (status: ChangeStatus) => status === ChangeStatus.ADDED;
    isDeletedElement = (status: ChangeStatus) => status === ChangeStatus.DELETED;
    isUneditedElement = (status: ChangeStatus) => status === ChangeStatus.UNEDITED;
}
